export default function Loading() {
  return <h1>Retrieving data...</h1>;
}
